import { render, staticRenderFns } from "./OrganizationChartNode.vue?vue&type=template&id=5205d34c&"
import script from "./OrganizationChartNode.vue?vue&type=script&lang=js&"
export * from "./OrganizationChartNode.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationChartNode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OrganizationChartNode.vue"
export default component.exports